import React from 'react';
import { Button, Form, Input, Row, Col } from 'antd';
import { observer, inject } from 'mobx-react';
const FormItem = Form.Item;
import Title from '@/components/Title';
import DatePicker from '../../components/DatePicker_Rang';
import styles from './TrafficReport.less';
import moment from 'moment';
import TrafficReportTable from '@/components/TrafficReport/TrafficReportTable';
import { getDaysArr } from '@/lib/GetDays';
import { formatDeviceId } from '../../lib/lib';
import { formItemLayout } from '../../const/FormConst';

@inject('trafficReportStore')
@observer
class TrafficReportForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dateArr: [],
      page_num: 1
    };
    this.startTime = null;
    this.endTime = null;
    this.deviceId = '';
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
    this.download = this.download.bind(this);
  }

  componentWillMount() {
    this.props.form.resetFields();
    this.setState({
      dateArr: []
    });
    this.props.trafficReportStore.trafficDate = [];
  }
  componentWillUnmount() {
    this.props.form.resetFields();
    this.props.trafficReportStore.trafficDate = [];
    this.props.trafficReportStore.trafficDateTotal = 1;
    this.props.trafficReportStore.page_num = 1;
  }
  onChangePage(pageNumber) {
    this.props.trafficReportStore.page_num = pageNumber;
    this.handleSubmit();
  }
  handleSubmit() {
    if (this.startTime && this.endTime) {
      this.props.form.validateFields((error, value) => {
        if (!error) {
          this.deviceId = formatDeviceId(value.traffic).join(',');
          if (this.deviceId) {
            this.props.trafficReportStore.page_num = 1;
          }
          this.props.trafficReportStore.loadTrafficReport(
            this.startTime,
            this.endTime,
            this.deviceId
          );
        }
      });
    } else {
      this.props.form.setFields({
        date: { errors: [new Error('请选择起止时间!')] }
      });
    }
  }

  onDateChange(value) {
    this.props.form.setFields({ date: value });
    this.startTime = moment(value[0]).format('YYYYMMDD');
    this.endTime = moment(value[1]).format('YYYYMMDD');
    this.setState({
      dateArr: getDaysArr(
        moment(value[0]).format('YYYY-MM-DD'),
        moment(value[1]).format('YYYY-MM-DD')
      )
    });
  }
  async download() {
    let fileUrl = await this.props.trafficReportStore.dowmloadReport(
      this.startTime,
      this.endTime,
      this.deviceId
    );
    let a = document.createElement('a');
    a.href = fileUrl;
    a.download = `${this.startTime}-${this.endTime}${
      this.deviceId ? '-' + this.deviceId : ''
    }`;
    a.click();
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className={styles.trafficReport}>
        <Title
          titleText={'搜索条件'}
          btn={{
            text: '报表下载',
            func: this.download,
            state: this.props.trafficReportStore.trafficDate.length
          }}
        />
        <div className={styles.searchContainer}>
          <Form onSubmit={this.handleSubmit}>
            <Row>
              <Col span={8}>
                <FormItem {...formItemLayout} label="设备编号">
                  {getFieldDecorator('traffic', {
                    rules: [
                      {
                        pattern: /^[0-9A-F,]*$/,
                        message: '请输入0~9,A~F!'
                      }
                    ]
                  })(<Input placeholder="请输入设备编号" />)}
                </FormItem>
              </Col>
              <Col span={10} offset={2}>
                <FormItem {...formItemLayout} label="起止时间">
                  {getFieldDecorator('date', {})(
                    <DatePicker onOk={this.onDateChange} />
                  )}
                </FormItem>
              </Col>
              <Col span={2} offset={2}>
                <Button type="primary" onClick={this.handleSubmit}>
                  {' '}
                  搜索
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
        <div className={styles.formContainer}>
          <TrafficReportTable
            data={this.props.trafficReportStore.trafficDate}
            dateArr={this.state.dateArr}
            onChangePage={this.onChangePage}
            page_num={this.props.trafficReportStore.page_num}
          />
        </div>
      </div>
    );
  }
}
const TrafficReport = Form.create()(TrafficReportForm);
export default TrafficReport;



// WEBPACK FOOTER //
// ./src/pages/TrafficReport/TrafficReport.js